import {
  atomFamily,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { recoilPersist } from "recoil-persist";
import { IShoppingCart } from "../utils/constants/dynamic/article";
import { useXoraiaValue } from "./useXoraia";

const { persistAtom } = recoilPersist();

export const USE_CART = atomFamily<IShoppingCart, string>({
  key: "USE_CART",
  default: { carts: [] },
  effects_UNSTABLE: [persistAtom],
});

export function useCart() {
  const { businessId } = useXoraiaValue();
  const [cart, setCart] = useRecoilState(USE_CART(businessId));

  return { cart, setCart };
}

export function useCartUpdater() {
  const { businessId } = useXoraiaValue();

  return useSetRecoilState(USE_CART(businessId));
}

export function useCartValue() {
  const { businessId } = useXoraiaValue();

  return useRecoilValue(USE_CART(businessId));
}
